import React, { useState, createContext } from "react";

// Create a context for the navigation state
export const NavigationContext = createContext();

const AdminNavigationProvider = ({ children }) => {
  const [open, setOpen] = useState({
    isManageUsers: true, // Default to Manage Users
    isManageProduct: false,
    isManageSeller: false,
  });

  return (
    <NavigationContext.Provider value={{ open, setOpen }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default AdminNavigationProvider;
